export default __webpack_public_path__ + "maps-examples-switch-styles-thumbnail-480-d6c8b89287bef86d3118ff40775aecce.png";